import clsx from 'clsx';
// mantine
import { UnstyledButton } from '@mantine/core';
// components
import { IConversationsUserPersona } from '@newo/api/gateway';
import ContextMenu from '@/pages/Conversations/components/Personas/components/PersonaItem/components/ContextMenu';
import PersonaData from '@/pages/Conversations/components/Personas/components/PersonaData';
import ActorData from '@/modules/Personas/components/ActorData';
// utils
import type { TUserPersonaFilters } from '@/pages/Conversations/Conversations.types';
// assets
import styles from '@/pages/Conversations/components/Personas/components/PersonaItem/PersonaItem.module.css';

interface PersonaItemProps {
    isSelected?: boolean;
    persona: IConversationsUserPersona;
    selectUserPersona: (persona?: IConversationsUserPersona) => void;
    onFilterChange: (filters: TUserPersonaFilters) => void;
}

const PersonaItem = ({
    isSelected,
    persona,
    selectUserPersona,
    onFilterChange
}: PersonaItemProps) => {
    const handleSelect = (connectors: string[]) => {
        selectUserPersona(persona);
        onFilterChange({
            connectors
        });
    };

    return (
        <div
            className={clsx(styles.persona, {
                [styles.isNotFound]: persona.not_found,
                [styles.isSelected]: isSelected,
                [styles.isActive]: persona.session_is_active
            })}
            onClick={() => {
                selectUserPersona(persona);
            }}
        >
            <UnstyledButton>
                <PersonaData
                    className={styles.item}
                    persona={persona}
                    onSelect={selectUserPersona}
                />
                {!persona.not_found && (
                    <>
                        {persona.actors.map((actor) => {
                            return (
                                <ActorData
                                    className={styles.item}
                                    data={actor}
                                    key={actor.id}
                                />
                            );
                        })}
                    </>
                )}
            </UnstyledButton>
            <ContextMenu
                className={styles.menu}
                persona={persona}
                onActorSelect={handleSelect}
            />
        </div>
    );
};

export default PersonaItem;
